export const QUESTIONS_X = [
//X01
// ①②③は通常型
{
  q: '①放射線による細胞の突然変異で起こる障害を【確率的】影響という．閾値(しきいち)は【なく】，線量が多くなるほど発生頻度が高くなるが，少ない線量でも発生しうる．線量と発生頻度の関係は一次関数のようになる．重症度は線量に依存【しない】．',
  s: 'X01', ch: '確率的影響と確定的影響',
},
{
  q: '②放射線による細胞死で起こる障害を【確定的】影響という．線量が【閾値】を超えない限り障害は出現せず，線量の増加とともに症状は【重篤】化する．',
  s: 'X01', ch: '確率的影響と確定的影響',
},
{
  q: '③放射線照射直後～数週間後にみられる放射線障害を【早】期障害といい，放射線照射後数ヵ月以降にみられる放射線障害を【晩】期障害という．',
  s: 'X01', ch: '確率的影響と確定的影響',
},

// ④はindent型
{
  q: '④確率的影響',
  s: 'X09', ch: '確率的影響と確定的影響',
  type: 'indent',
  rows: [
    { level: 0, text: '早期障害：なし' },
    { level: 0, text: '晩期障害：' },
    { level: 1, text: '【発がん】(【甲状腺癌】，【白血病】など)' },
    { level: 1, text: '【遺伝的】影響 (※ ただしヒトでは【確認されていない】)' },
  ]
},
{
  q: '⑤確定的影響',
  s: 'X05',
  ch: '確率的影響と確定的影響',
  type: 'indent',
  rows: [
    { level: 0, text: '早期障害：' },
    { level: 1, text: '【皮膚】炎, 【皮膚】潰瘍, 【脱毛】' },
    { level: 1, text: '粘膜障害 … 【口腔】粘膜炎, 【唾液分泌】障害(→ 齲歯), 【味】覚障害, 【下痢】・血便など' },
    { level: 1, text: '【放射線宿酔】… 頭痛, 嘔吐, 倦怠感など' },
    { level: 1, text: '骨髄抑制 … ❶【リンパ球】, ❷【好中球】, ❸【血小板】, ❹【赤血球】の順に低下' },
    { level: 1, text: '【不妊】' },
    { level: 0, text: '晩期障害：' },
    { level: 1, text: '【白内障】, 【甲状腺】機能低下症, 【腸閉塞】' },
    { level: 1, text: '放射線性【肺炎】(亜急性), 肺線維症' },
    { level: 1, text: '胎児【奇形】, 【精神発達遅滞】' },
  ]
},
{
  q: '⑥放射線性肺炎；照射後【2】~【6】ヵ月後に生じる．照射部位に一致した肺炎を呈する．治療は経過観察，低O2血症を伴う重症例は【ステロイド】投与',
  s: 'X01', ch: '確率的影響と確定的影響',
},
{
  q: '①1秒間に壊変する放射性同位元素の量を【放射能】といい，放射線を出す能力を示す．単位は【Bq】(【ベクレル】)．',
  s: 'X01', ch: '放射線の線量と単位',
},
{
  q: '②X線あるいはγ線で1kgの空気を照射した際，電離により1Cの電気量が生ずる線量を【照射線量】という．単位はC/kg．',
  s: 'X01', ch: '放射線の線量と単位',
},
{
  q: '③物質1kgに1Jのエネルギーを与える線量を【吸収線量】といい，身体にどれほどの線量が吸収されたかを示す．単位は【Gy】(【グレイ】)．',
  s: 'X01', ch: '放射線の線量と単位',
},
{
  q: '④吸収線量に放射線加重係数(【X】線・β線・【γ】線は1，中性子線は5～20，α線は20)をかけたものを【等価線量】といい，単位は【Sv】(【シーベルト】)である．',
  s: 'X01', ch: '放射線の線量と単位',
},
{
  q: '⑤等価線量に組織荷重係数をかけたものを【実効線量】といい，単位は【Sv】である．放射線の種類に加え，組織の感受性を考慮したものである．',
  s: 'X01', ch: '放射線の線量と単位',
},
{
  q: '⑥放射線防護のために用いられる放射線の単位は【Sv】である．人体への影響を表す実効線量は【外部】被曝線量と【内部】被曝線量の合計である．',
  s: 'X01', ch: '放射線の線量と単位',
},
{
  q: '①放射線被曝の種類には【公衆】被曝，【医療】被曝，【職業】被曝がある．',
  s: 'X01', ch: '線量限度',
},
//ここに画像のやついれる②
{
  q: '③公衆被曝の線量限度は【1】mSv/年である．',
  s: 'X01', ch: '線量限度',
},
{
  q: '④【医療】被曝の線量限度は設定されておらず，最適化が重要となる．',
  s: 'X01', ch: '線量限度',
},

{
  q: '⑥従来は妊娠可能女性の腹部X線検査は【月経開始】後【10】日以内に行うとされていたが(【10 days-rule】)，現在では医療上必要があれば妊娠の有無にかかわらずX線検査を行う．',
  s: 'X01', ch: '線量限度',
},
{
  q: '⑦以下の❶～❹を放射線被曝量の少ない順に並べよ．❶PET ❷胸部X線 ❸ダイナミックCT ❹IVR　(被曝量の少ない方から) 【❷】＜【❶】＜【❸】＜【❹】＜放射線治療',
  s: 'X01', ch: '線量限度',
},
{
  q: '①放射線による外部被曝防護の3原則',
  s: 'B02',
  ch: '放射線防護',
  type: 'list',
  note: '放射線による外部被曝防護の3原則',
  items: [
    { label: '❶', term: '距離', desc: 'なるべく放射線源との【距離】を長くする．' },
    { label: '❷', term: '遮蔽', desc: '鉛などの原子番号の大きな物質を含んだ【遮蔽】物を置くことで，放射線被曝線量を少なくできる．' },
    { label: '❸', term: '時間', desc: '被曝【時間】をなるべく短くする．' },
  ]
},
// X02
// X03
{
  q: 'IVRの分類と手技・適応',
  s: 'X02',
  ch: 'IVR',
  type: 'grouped',
  categories: [
    {
      label: '血管系IVR',
      groups: [
        {
          label: '血管塞栓術',
          rows: [
            { term: '【動脈】塞栓術', desc: '脳動脈瘤(コイル塞栓)，【肝細胞癌】や子宮筋腫(栄養血管の塞栓)，消化管などの種々の【止血】' },
            { term: '静脈塞栓術', desc: '胃静脈瘤(BRTO)' },
          ]
        },
        {
          label: '留置術',
          rows: [
            { term: 'ステント留置術', desc: '頸動脈狭窄症' },
            { term: 'ステントグラフト留置術', desc: '大動脈瘤' },
            { term: 'リザーバー留置術', desc: '転移性肝細胞癌' },
            { term: '【中心静脈ポート】留置術', desc: '高カロリー輸液，抗がん剤投与' },
            { term: '【下大静脈フィルター】留置術', desc: 'DVTに対する肺塞栓症予防' },
          ]
        },
        {
          label: '血管内注入療法',
          rows: [
            { term: '抗がん剤(【動注化学療法】)', desc: '【肝細胞癌】，上顎癌，咽頭癌，喉頭癌' },
            { term: '血栓溶解薬', desc: '急性期脳梗塞' },
          ]
        },
        {
          label: '血管形成術',
          rows: [
            { term: '経皮的血管形成術(PTA)', desc: '腎血管性高血圧(特に線維筋性異形成)，閉塞性動脈硬化症' },
            { term: '【冠動脈インターベンション(PCI)】', desc: '狭心症，急性心筋梗塞' },
          ]
        },
        {
          label: 'カテーテルアブレーション',
          rows: [
            { term: '', desc: 'WPW症候群，AF' },
          ]
        },
      ]
    },
    {
      label: '非血管系IVR',
      groups: [
        {
          label: '',
          rows: [
            { term: '', desc: 'CTガイド下生検，膿瘍ドレナージ(肝膿瘍)，ラジオ波熱凝固術(肝細胞癌)，消化管ステント留置術など' },
          ]
        }
      ]
    },
  ]
},
// X04



]